import React from 'react';
import { Link } from 'react-router-dom';
import styles from './Development.module.scss';

const Development = () => {
    return (
        <>
            <div className={styles.mainContainer}>
                <h2 className={styles.innerContainer}>Web Development</h2>
                <p className={styles.description}>
                    We build modern, responsive, and SEO-friendly websites that elevate your online presence. From custom CMS to full-stack web applications, our Surat-based developers deliver reliable, scalable, and visually impressive solutions.
                </p>
                <div className={styles.linksGrid}>
                    <Link to="/portfolio" state={{ filter: "Web" }} className={styles.link}>Frontend Development</Link>
                    <Link to="/portfolio" state={{ filter: "Web" }} className={styles.link}>Backend Development</Link>
                    <Link to="/portfolio" state={{ filter: "Web" }} className={styles.link}>E-commerce Development</Link>
                </div>
            </div>
        </>
    );
};

export default Development;
